export enum Role {
  Owner = "OWNER",
  Admin = "ADMIN",
  CoOrdin = "CO_ORDIN",
  MgrOps = "MGR_OPS",
  MgrAdmin = "MGR_ADMIN"
}

export enum Action {
  Create = "CREATE",
  Read = "READ",
  Update = "UPDATE",
  Delete = "DELETE"
}

export enum AccountType {
  Subscriber = "SUBSCRIBER",
  Client = "CLIENT",
  Supplier = "SUPPLIER"
}

export enum Page {
  Home = "home",

  Clients = "clients",
  Venues = "venues",
  Suppliers = "suppliers",
  Resources = "resources",

  Roster = "roster",
  AttendanceRegister = "attendance-register",
  TimesheetRegister = "timesheet-register",
  SignOnSignOff = "sign-on-sign-off-register",
  IncidentReports = "incident-reports",

  Details = "details",
  Members = "members",
  AssetLibrary = "asset-library",
  AccreditationV2 = "accreditation-v2",
  ComplianceEligibility = "compliance-eligibility",
  Logs = "logs"
}

export type ResourceKey = string;
